var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6128",
    "data-name": "Group 6128",
    transform: "translate(0.197 0.166)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2241",
    "data-name": "Rectangle 2241",
    width: 128,
    height: 128,
    transform: "translate(-0.197 -0.166)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6118",
    "data-name": "Group 6118",
    transform: "translate(20.07 20.069)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M0,44A44,44,0,1,1,44,88,44.05,44.05,0,0,1,0,44Zm4.555,0A39.445,39.445,0,1,0,44,4.555,39.489,39.489,0,0,0,4.555,44ZM31.68,60.38a2.277,2.277,0,1,1,0-4.555H56.112a2.277,2.277,0,1,1,0,4.555ZM54.354,32.508A4.348,4.348,0,1,1,58.7,36.857,4.348,4.348,0,0,1,54.354,32.508Zm-29.611,0a4.348,4.348,0,1,1,4.35,4.349A4.349,4.349,0,0,1,24.743,32.508Z",
    transform: "translate(-0.268 -0.235)",
    fill: "#b99354"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.b684e7b5952371fad18d93fad0f9e163.svg";
export { ForwardRef as ReactComponent };